import { KeyTitlesAddItem } from "./KeyTitlesAddItem";
import { ReuseTooltip } from "../../ui";
import { Button } from "@mui/material";
import { useState } from "react";
import { JobTitlesType } from "../../../types/enums";

type Props = {
  isReachedLimit: boolean;
  roleId: string;
  titleType: JobTitlesType;
};
export const KeyTitleAddItemBlock = ({
  roleId,
  isReachedLimit,
  titleType,
}: Props) => {
  const [addIsOpen, setAddIsOpen] = useState(false);
  return (
    <>
      {addIsOpen ? (
        <KeyTitlesAddItem
          setIsOpen={setAddIsOpen}
          roleId={roleId}
          isIgnored={titleType === JobTitlesType.ignored}
        />
      ) : (
        <ReuseTooltip
          text={isReachedLimit ? "" : "Limit reached"}
          hideChildren={false}
        >
          <Button
            variant="text"
            className="no-drag"
            onClick={() => isReachedLimit && setAddIsOpen(true)}
            sx={{
              color: "rgba(31, 41, 50, 0.6)",
              textWrap: "nowrap",
              backgroundColor: "transparent",
              maxHeight: "32px",
              "&:hover": {
                color: "#82848d",
              },
            }}
          >
            + Add Title
          </Button>
        </ReuseTooltip>
      )}
    </>
  );
};
